import { type FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalContext } from '@/components/Modals/Modal/config';
import { StringSmall, StringXSmall } from '@/components/Typography/Typography';
import { Button } from '@/components/ui/Button/Button';
import { CurrencyImage } from '@/components/ui/CurrencyImage/CurrencyImage';
import { Plus } from '@/components/ui/Plus/Plus';
import { useAppSelector } from '@/redux/store';

import css from './styles.module.scss';

const CoinBalance: FC = () => {
  const { t } = useTranslation();
  const { isOpen, openModal, secondModal } = useContext(ModalContext);
  const coinBalance = useAppSelector((state) => state.user.user?.balance.tgem);

  const onClick = (): void => {
    if (isOpen) {
      secondModal.openModal({
        renderKind: 'coinDeposit',
        props: { source: 'coin_balance_widget' },
      });
    } else {
      openModal({
        renderKind: 'coinDeposit',
        props: { source: 'coin_balance_widget' },
      });
    }
  };

  return (
    <div className={css.coinBalance}>
      <CurrencyImage size={'2rem'} kind="tgem" />
      <div className="flex flex-col justify-between">
        <StringXSmall weight="regular" className="!text-white/40">
          {t('Balance')}
        </StringXSmall>
        <StringSmall weight="bold" className="!text-white">
          {coinBalance}
        </StringSmall>
      </div>
      <Button className="!w-auto" onClick={onClick}>
        <Plus
          className="!w-[1.875rem] !h-[1.875rem]"
          variant={'green-header'}
        />
      </Button>
    </div>
  );
};

export { CoinBalance };
